export default "__VITE_ASSET__HGxTDBWp__"